import React, { useState, useEffect } from 'react';
import './AboutUsBanner.css';
import AboutUsBannervideo from '../../../assets/images/career/careerheader.mp4';

const AboutUsBanner = () => {
  const textArray = [
    "Accelerate Digital Transformation",
    "Innovative Solutions for a Better Tomorrow",
    "Empowering Your Business",
    "Driving Excellence in Every Project"
  ];

  const [currentText, setCurrentText] = useState(textArray[0]);
  const [textIndex, setTextIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTextIndex((prevIndex) => (prevIndex + 1) % textArray.length);
    }, 5000); // Change text every 5 seconds

    return () => clearInterval(interval);
  }, [textArray.length]);

  useEffect(() => {
    setCurrentText(textArray[textIndex]);
  }, [textIndex, textArray]);

  return (
    
    <div className="banner-container">
      <div className="video-banner">
        <video autoPlay loop muted>
          <source src={AboutUsBannervideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
   
      <div className="text-overlay">
        <h1>{currentText}</h1>
      </div>
    </div>
  );
};

export default AboutUsBanner;
